function listenerForCheckBoxChange(checkbBoxElement, variantId, variantPrice) {
  const isChecked = checkbBoxElement.checked;
  const idForDataInjection = `#${variantId}-add-on-data`;

  let htmlToInject = '';
  if (isChecked) {
    htmlToInject = `<input id="${variantId}-data" type="text" name="properties[_sku_qty_${variantId}]" value="${1}">`;
  }

  $(idForDataInjection).html(htmlToInject);
}

function changeData(variantId, newQuantity) {
  const idForDataInjection = `#${variantId}-add-on-data`;

  let htmlToInject = '';
  htmlToInject = `<input id="${variantId}-data" type="text" name="properties[_sku_qty_${variantId}]" value="${newQuantity}">`;

  $(idForDataInjection).html(htmlToInject);
}

// function minusClick(variantId, maxQuantity) {
//   // const checkboxElement = $(`#${variantId}-checkbox`)[0];

//   // const isChecked = checkboxElement ? checkboxElement.checked : false;
//   // if (!isChecked) {
//   //   return;
//   // }
//   console.log('minus click called');
//   const id = `#${variantId}-quantity`;
//   const element = $(id);
//   console.log('element is: ', element);
//   let currentValue = +element.val();
//   if (isNaN(currentValue)) {
//     currentValue = 1;
//   }
//   let newQuantity = 0;
//   if (currentValue <= 1) {
//     newQuantity = 0;
//   } else {
//     newQuantity = currentValue - 1;
//   }
//   element.val(newQuantity);
//   changeData(variantId, newQuantity);
// }

// function plusClick(variantId, maxQuantity) {
//   console.log('plus click called');

//   // const checkboxElement = $(`#${variantId}-checkbox`)[0];

//   // const isChecked = checkboxElement ? checkboxElement.checked : false;
//   // if (!isChecked) {
//   //   return;
//   // }

//   const id = `#${variantId}-quantity`;
//   const element = $(id);
//   let currentValue = +element.val();
//   if (isNaN(currentValue)) {
//     currentValue = 0;
//   }
//   let newQuantity = 0;
//   if (currentValue >= maxQuantity) {
//     newQuantity = maxQuantity;
//   } else {
//     newQuantity = currentValue + 1;
//   }
//   element.val(newQuantity);
//   changeData(variantId, newQuantity);
// }
